import { LinkTypeUI } from './../models/link-type';

export type LinkTypeState = LinkTypeUI[];

export const initialState: LinkTypeState = [];
